import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import styles from './CookieConsent.module.scss';
import { wait } from '@testing-library/user-event/dist/utils';
// import ReactPixel from 'react-facebook-pixel';

const CookieConsent = () => {
  const [cookies, setCookie] = useCookies(['cookie-consent']);
  const [showBanner, setShowBanner] = useState(!cookies['cookie-consent']);
  // const [showBanner, setShowBanner] = useState(!sessionStorage.getItem('cookie-consent'));

  useEffect(() => {
    if (cookies['cookie-consent'] === 'accepted') {
        wait(1000).then(() => {
        window.fbq('consent', 'grant');
        // window.fbq('track', 'PageView');
        setShowBanner(!cookies['cookie-consent'])
      });
    }
  })

  const handleAccept = () => {
    setCookie('cookie-consent', 'accepted', { path: '/' });
    // ReactPixel.grantConsent();
    window.fbq('consent', 'grant');
    // sessionStorage.setItem('cookie-consent', 'accepted');
    setShowBanner(false);
  };
  const handleDecline = () => {
    // ReactPixel.revokeConsent();
    window.fbq('consent', 'revoke');
    // setCookie('cookie-consent', 'decline', { path: '/' });
    // sessionStorage.setItem('cookie-consent', 'decline');
    setShowBanner(false);
  };

  if (showBanner) {
    return (
      <div className={`cookie-consent ${styles.cookieConsentBanner}`}>
        <p className={styles.cookieConsentBannerText}>
          Vi använder kakor (cookies) för att förbättra webbplatsen och din användarupplevelse.
        </p>
        <button className={`${styles.cookieConsentBannerButton} ${styles.accept}`} onClick={handleAccept}>Acceptera</button>
        <button className={`${styles.cookieConsentBannerButton} ${styles.decline}`} onClick={handleDecline}>Neka</button>
        <a href="https://elevert.se/integritetspolicy"><button className={`${styles.cookieConsentBannerButton} ${styles.info}`} >Läs mer</button></a>
      </div>
    );
  }

  return null;
};

export default CookieConsent;
